import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { BaseComponent } from 'src/app/secondadmin/base.component';
import { ClientService } from 'src/app/services/clients/client.service';
import { MasterService } from 'src/app/services/master/master.service';
import { CommonMessages } from 'src/app/shared/messages/messages.enum';

@Component({
  selector: 'app-list-subscription',
  templateUrl: './list-subscription.component.html',
  styleUrls: ['./list-subscription.component.css']
})
export class ListSubscriptionComponent extends BaseComponent implements OnInit {
  @ViewChild('searchText', { static: true }) searchText: ElementRef;

  companyID = 0;
  selectedCompany : any = '';
  selectedStatus: any = '';
  currentUser;
  getCompanyobj: any = [];
  categoryObj: any = [];
  webCatTotal: number = 0;
  slCatPage = 1;
  slCatLimit = 10;
  slCatSkip = 0;
  slCatord = "asc";
  slCatColname = "title";
  constructor(private clientService: ClientService,
    private masterService:MasterService) {
    super();
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem('userData'));

    if (this.currentUser.admin_customer_id != '0') {
      this.companyID = this.currentUser.admin_customer_id;
      this.selectedCompany = this.companyID;
      this.getSubscriptionList();
    }
    if (this.currentUser.admin_customer_id == '0') this.getCompany();
  }
  getCompany() {
    this.clientService.getBUCompanies().subscribe(data => {
      this.getCompanyobj = data.data;
      const working = this.bindWorkingCompany(this.getCompanyobj);
      if (working) {
        this.selectedCompany = working;
        this.getSubscriptionList();
      }
      this.ngxSpinnerService.hide();
    }, error => {
      console.log(error);
    });
  }

  onCompanyChange(value?: any) {
    if (value !== undefined) {
      this.selectedCompany = value;
    }
    this.slCatPage = 1;
    this.getSubscriptionList();
  }
  onStatusChange(value?: any) {
    if (value !== undefined) {
      this.selectedStatus = value;
    }
    this.slCatPage = 1;
    this.getSubscriptionList();
  }
  resetFilters() {
    this.selectedStatus = '';
    this.slCatPage = 1;
    this.slCatSkip = 0;
    if (this.searchText && this.searchText.nativeElement) {
      this.searchText.nativeElement.value = '';
    }
    if (this.companyID == 0) {
      this.selectedCompany = this.bindWorkingCompany(this.getCompanyobj) || '';
    }
    this.getSubscriptionList();
  }
  getSubscriptionList() {
    let searchTerm = this.searchText.nativeElement.value;
    this.slCatSkip = (this.slCatPage - 1) * this.slCatLimit;

    if (this.selectedCompany !== "") {
      this.ngxSpinnerService.show();

      this.masterService.getSubscriptionList(this.selectedCompany,this.slCatLimit, this.slCatSkip, searchTerm,this.slCatColname,this.slCatord,this.selectedStatus).subscribe(data => {
        this.ngxSpinnerService.hide();
        // console.log(data);

        if (data.status) {
          if (data.data.rows == null) { this.categoryObj = [] }
          else { this.categoryObj = data.data.rows }
          this.webCatTotal = data.data.total;
        } else {
          this.categoryObj = [];
          this.webCatTotal = 0;
        }
      }, error => { console.log(error);this.ngxSpinnerService.hide(); });
    } else {
      this.categoryObj = [];
      this.selectedCompany = "";
      this.webCatTotal = 0;
      this.ngxSpinnerService.hide();
    }
  }
  setOrder(value: string) {
    this.slCatColname = value
    if (this.slCatord == 'asc') {
      this.slCatord = 'desc'
    } else {
      this.slCatord = 'asc'
    } this.getSubscriptionList()
  }
  editPost(id:any) {
    localStorage.setItem("edit_subscription_id", id);
    localStorage.setItem("edit_subscription_company_id", this.selectedCompany);
    this.router.navigate(['/corporate/edit-subscription']);
  }
  updateStatus(event, id, status) {
    event.preventDefault();
    let obj = {
      isactive: (status == true) ? false : true,
      // company:this.selectedCompany,
      // id:id
    }
    this.confirmationDialogService.confirm('Please confirm', 'Are you sure you want to change the status To' + ((obj.isactive) ? ' Active?' : ' In Active?'), 'Ok', 'Cancel')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.masterService.updateSubscriptionDataStatus(this.selectedCompany,id,obj).subscribe(data => {
            if (data.status) {
              this.toastrService.success("Status Updated Successfully");
              this.getSubscriptionList();
            } else {
              this.toastrService.error(data.message);
            }
            this.ngxSpinnerService.hide();
          });
        }
      }).catch(() => console.log(CommonMessages.dialogDismissMessage));
  }
  delCategory(event, id) {
    event.preventDefault();
    this.confirmationDialogService.confirm('Please confirm', 'ARE YOU SURE YOU WANT TO DELETE ?', 'Ok', 'Cancel')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.masterService.deleteSubscriptionCategory(this.selectedCompany,id).subscribe(data => {
            if (data.status) {
              this.toastrService.success("Subscription Deleted Successfully");
              this.getSubscriptionList();
            } else {
              this.toastrService.error(data.message);
            }
            this.ngxSpinnerService.hide();
          });
        }
      }).catch(() => console.log(CommonMessages.dialogDismissMessage));
  }
  ngAfterViewInit() {
    this.searchText.nativeElement.value = '';
    this.ngxSpinnerService.show();
    fromEvent(this.searchText.nativeElement, 'keyup')
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => {
          this.slCatSkip = 0;
          this.slCatPage = 1;
        }),

        switchMap(data => this.masterService.getSubscriptionList(this.selectedCompany,this.slCatLimit, this.slCatSkip, this.searchText.nativeElement.value,this.slCatColname,this.slCatord,this.selectedStatus))

      )
      .subscribe(res => {
        if (res.status) {
          if (res.data.rows == null) { this.categoryObj = [] }
          else { this.categoryObj = res.data.rows }
          this.webCatTotal = res.data.total;
        } else {
          this.categoryObj = [];
          this.webCatTotal = 0;
        }
        this.ngxSpinnerService.hide();
      },error => {
        this.categoryObj = [];
        this.webCatTotal = 0;
        this.ngxSpinnerService.hide();
      });
  }
}
